import { Redirect, useLocation, useParams } from 'react-router-dom';

export function LegacyTldRedirect({ baseUrl }: { baseUrl?: string }) {
  const { extraction_token } = useParams<{ extraction_token: string }>();
  const { search } = useLocation();

  return (
    <Redirect
      to={`${baseUrl}/traffic-light-detection/${extraction_token}${search}`}
    />
  );
}
